<template>
  <vx-card no-shadow>
    <vs-input
      type="password"
      class="w-full"
      label-placeholder="Old Password"
      v-validate="'required'"
      name="old"
      v-model="old_password"
    />
    <p class="text-danger mt-2">{{ errors.first("old") }}</p>
    <vs-input
      type="password"
      class="w-full"
      label-placeholder="New Password"
      v-validate="'required'"
      ref="new"
      name="new"
      v-model="new_password"
    />
    <p class="text-danger mt-2">{{ errors.first("new") }}</p>
    <vs-input
      type="password"
      class="w-full"
      label-placeholder="Confirm Password"
      v-validate="'required|confirmed:new'"
      name="password"
      v-model="confirm_new_password"
    />
    <p class="text-danger mt-2">{{ errors.first("password") }}</p>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="submitData"
        >Save Changes</vs-button
      >
      <vs-button class="ml-4 mt-2" type="border" color="warning"
        >Reset</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      old_password: "",
      new_password: "",
      confirm_new_password: "",
      first_name: "",
      last_name: "",
      USDOT: "",
      time_zone: "",
      data: "",
      organistion: "",
      address: "",
      postal: "",
      cperson: "",
      city: "",
      mobile: null,
      email: "",
      region: "",
      country: "",
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          const obj = {
            company_name: this.organistion,
            address: this.address,
            postal_code: this.postal,
            contact_person: this.cperson,
            city: this.city,
            region: this.region.value,
            phone: this.mobile,
            email: this.email,
            country: this.country.value,
            first_name: this.first_name,
            last_name: this.last_name,
            USDOT: this.USDOT,
            time_zone: this.time_zone,
            old_password: this.old_password,
            password: this.new_password,
          };
          this.$store
            .dispatch("company/addItem", obj)
            .then(() => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Success",
                text: "Edited",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
              });
            })
            .catch((err) => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Error",
                text: err.response.data.response,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
              });
            });
        }
      });
    },
    mounted() {
      this.$store.dispatch("company/fetchDataListItems").then((response) => {
        (this.password = response.data.password),
          (this.organistion = response.data.company_name),
          (this.address = response.data.address),
          (this.postal = response.data.postal_code),
          (this.cperson = response.data.contact_person),
          (this.city = response.data.city),
          (this.region = response.data.region),
          (this.mobile = response.data.phone),
          (this.email = response.data.email),
          (this.country = response.data.country),
          (this.first_name = response.data.first_name),
          (this.last_name = response.data.last_name),
          (this.USDOT = response.data.USDOT),
          (this.time_zone = response.data.time_zone);
        // console.log(this.password);
      });
    },
  },
  mounted() {
    this.created();
    console.log(this.password);
  },
};
</script>
